<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table :rowKey="record => record.id" :columns="columns" :dataSource="data" :pagination="false"
        :scroll="{ x: '100%' }" :rowSelection="computedSelect" :loading="loading">
        <template slot="code" slot-scope="code">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{ code }}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="name" slot-scope="name">
          <div class="text-wrap">
            <div class="font-weight-bold text-wrap">{{ name }}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <!--        <template slot="description" slot-scope="description">
            <div>{{description}}</div>
          </template>-->
        <template slot="category" slot-scope="category">
          <div>{{ category.name }}</div>
        </template>
        <template slot="school_class" slot-scope="school_class">
          <div>{{ school_class ? school_class.name : null }}</div>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
            <!-- <a-tooltip
                placement="top"
                title="Create inward transaction"
              >
              <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showInwardTransactionModal(record)">
                <span class="btn-addon">
                  <i class="btn-addon-icon fa-lg fe  fe-plus-square" />
                </span>
              </a>
              </a-tooltip>
              <a-tooltip
                placement="top"
                title="Create outward transaction"
              >
              <a href="javascript:" class="btn btn-sm btn-warning mr-2" @click="showOutwardTransactionModal(record)">
                <span class="btn-addon">
                  <i class="btn-addon-icon fa-lg fe fe-minus-square" />
                </span>
              </a>
              </a-tooltip> -->
            <a-tooltip placement="top" title="Edit book">
              <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" v-if="rolesetting.editable" @click="showEditModal(record)">
                <span class="btn-addon">
                  <i class="btn-addon-icon fe fe-edit" />
                </span>
                Edit
              </a>
            </a-tooltip>

            <a-tooltip placement="top" title="Delete book">
              <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" v-if="rolesetting.deletable" @click="handleDelete(record)">
                <span class="btn-addon">
                  <i class="btn-addon-icon fe fe-trash" />
                </span>
                Delete
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
    <edit-book @onEdited="handleAfteredit"></edit-book>
    <inward-transaction @onInwardTransaction="handleAfteredit"></inward-transaction>
    <outward-transaction @onOutwardTransaction="handleAfteredit"></outward-transaction>
  </div>
</template>

<script>
import EditBook from '@/components/library/books/edit'
import InwardTransaction from '@/components/inventory/master/product/inwardTransaction'
import OutwardTransaction from '@/components/inventory/master/product/outwardTransaction'

const columns = [
  { title: 'Code', width: 100, dataIndex: 'code', scopedSlots: { customRender: 'code' } },
  { title: 'Title', width: 250, dataIndex: 'title', scopedSlots: { customRender: 'title' } },
  // { title: 'Description', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Category', width: 150, dataIndex: 'category', scopedSlots: { customRender: 'category' } },
  // { title: 'Sub Category', width: 100, dataIndex: 'sub_category.name', scopedSlots: { customRender: 'sub_category.name' } },
  { title: 'Rack', width: 150, dataIndex: 'rack_name', scopedSlots: { customRender: 'rack_name' } },
  { title: 'Class', width: 100, dataIndex: 'school_class', scopedSlots: { customRender: 'school_class' } },
  { title: 'Total Copies', align: 'center', width: 100, dataIndex: 'total_quantity', scopedSlots: { customRender: 'total_quantity' } },
  // { title: 'Issued Copies', align: 'center', width: 80, dataIndex: 'issued_quantity', scopedSlots: { customRender: 'issued_quantity' } },
  { title: 'Available Copies', align: 'center', width: 80, dataIndex: 'balance_quantity', scopedSlots: { customRender: 'balance_quantity' } },
  // { title: 'Min. Qty.', width: 100, dataIndex: 'product_stock.min_quantity', scopedSlots: { customRender: 'product_stock.min_quantity' } },
  // { title: 'Max. Qty.', width: 100, dataIndex: 'product_stock.max_quantity', scopedSlots: { customRender: 'product_stock.max_quantity' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'BooksTable',
  components: {
    EditBook,
    InwardTransaction,
    OutwardTransaction,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      // data: [],
    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function () {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    /* fetchdata() {
      let api = '/api/inventory/product/stock/all'
      this.data.length = 0
      this.$http.get(api)
        .then((resp) => {
          this.data = resp.data.data
        })
        .catch(err => {
          console.error(err)
        })
    }, */
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showInwardTransactionModal(record) {
      this.$eventBus.$emit('showInwardTransactionForm', record)
    },
    showOutwardTransactionModal(record) {
      this.$eventBus.$emit('showOutwardTransactionForm', record)
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this book?',
        content: `Clicking yes will delete this book "${record.title}"`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/library/books/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              console.log('resp: ', resp)
              // check the custom resp status: resp.data.status (not resp.status)
              if (resp.data.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: resp.data.message,
                })
              } else {
                this.$nprogress.done()
                this.$notification['warning']({
                  message: 'Book cannot be deleted!',
                  description: resp.data.message,
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
